'use client';

import { Fragment, useEffect } from 'react';
import { useLocale } from 'next-intl';
import { setTitleTag } from '@/src/utils/titleTag';
import Accordion from '@components/Accordion';
import ContactSidebarLayout from '@components/ContactSidebarLayout';
import HeroHeader from '@components/HeroHeader';
import getOption from '@/src/utils/getOption';
import replaceContact from '@/src/utils/replaceContact';
import NotFoundPage from '../not-found';
import useATSName from '@/src/utils/useATSName';

import en from './en.json';
import no from './no.json';
import sv from './sv.json';
import de from './de.json';
import pl from './pl.json';

const contents = {
  en,
  no,
  sv,
  de,
  pl,
};

export default function ClientPage() {
  const locale = useLocale();
  const ats = useATSName();
  const content = contents[locale as keyof typeof contents];
  const title = content.title;
  useEffect(() => {
    if (title) {
      setTitleTag(title);
    }
  }, [title]);

  if (!getOption('HAS_AUCTIONS')) {
    return <NotFoundPage />;
  }

  return (
    <>
      <ContactSidebarLayout title={title} image='/images/pages/faq.jpg'>
        <p
          className='mb-8 text-xl text-brand'
          dangerouslySetInnerHTML={{
            __html: replaceContact(content.intro, ats),
          }}
        />
        {content.sections.map((section, index) => (
          <Fragment key={index}>
            <h2 className='mb-1 mt-5 text-xl font-bold text-brand'>
              {section.title}
            </h2>
            {section.points.map((panel, index2) => {
              const content =
                typeof panel.content === 'string'
                  ? replaceContact(panel.content, ats)
                  : replaceContact(
                      panel.content[
                        getOption(
                          'DEFAULT_LOCALE'
                        ) as keyof typeof panel.content
                      ],
                      ats
                    );
              return (
                <Accordion
                  key={index2}
                  title={replaceContact(panel.header, ats)}
                  content={String(content)}
                  theme='outline'
                />
              );
            })}
          </Fragment>
        ))}
        <div className='accordion flex flex-col gap-2'></div>
      </ContactSidebarLayout>
    </>
  );
}
